import gql from 'graphql-tag'

export const CREATE_STEP = gql`
  mutation CreateStep($name: String!, $stepTypeId: Int!, $needTool: Boolean!) {
    createStep(
      data: {
        name: $name
        stepType: { connect: { id: $stepTypeId } }
        needTool: $needTool
      }
    ) {
      id
      name
    }
  }
`

export const UPDATE_STEP = gql`
  mutation UpdateStep(
    $id: Int!
    $name: String!
    $stepTypeId: Int!
    $needTool: Boolean!
  ) {
    updateStep(
      id: $id
      data: {
        name: $name
        stepType: { connect: { id: $stepTypeId } }
        needTool: $needTool
      }
    ) {
      id
      name
    }
  }
`

export const DELETE_STEP = gql`
  mutation DeleteStep($id: Int!) {
    deleteStep(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Step.js